module.exports = __webpack_public_path__ + "img/xander-opcion-2.f95e30b9.png";